import { CreditLineForm } from '@/components/billing';
import { useCompanyContext } from '@/components/company-shell';

/**
 * Page `/company/:companyId/credit-line` — "Línea de crédito" tab.
 * Reads the shell context and renders the `CreditLineForm` for the
 * loaded company.
 */
export const CreditLinePage = () => {
  const { company, refetch } = useCompanyContext();

  return <CreditLineForm company={company} refetch={refetch} />;
};
